import {
  Flex,
  Text,
  View,
  Button,
} from '@instructure/ui'

export const DoneButton = ({
  onClick,
}) => {

  return (
    <Flex direction="row" alignItems="center" justifyItems="center">
      <Flex.Item>
        <View as="div" className="done-button-container">
          <Button display="block" color="primary" onClick={onClick} data-qa="test-results-done-button">
            <Text transform="uppercase" weight="bold">{_t('Done')}</Text>
          </Button>
        </View>
      </Flex.Item>
    </Flex>
  )
}
